export default __webpack_public_path__ + "static/media/SpeachBubble.0d1560cb.png";